var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"All","stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":2},React.createElement("g",{"id":"GUI_part-(v2)","transform":"translate(-1646.000000, -912.000000)","fillRule":"nonzero"},React.createElement("polygon",{"id":"Check","points":"1658.27451 912.311768 1659.72549 913.688232 1651.41085 922.452998 1646.27451 917.038595 1647.72549 915.66213 1651.41085 919.547002"})))]);
}

Check.defaultProps = {"viewBox":"0 0 14 11","version":"1.1"};

module.exports = Check;

Check.default = Check;
